import { render, staticRenderFns } from "./ParticipantDetails.vue?vue&type=template&id=f11b7164"
import script from "./ParticipantDetails.vue?vue&type=script&lang=js"
export * from "./ParticipantDetails.vue?vue&type=script&lang=js"
import style0 from "./ParticipantDetails.vue?vue&type=style&index=0&id=f11b7164&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports